import "./CommitmentInfo.scss";

const CommitmentInfo = () => {
  return (
    <div className="commitment-info">
      <h2>NOTRE ENGAGEMENT</h2>
      <div>
        <img src="images/commitment/engagement.png" alt="engagement" />
      </div>
      <div className="info">
        <h2>
          NOTRE <br />
          ENGAGEMENT
        </h2>
        <p>
          Soucieux de s'inscrire dans une démarche responsable, nous avons pour
          objectif de réduire notre empreinte environnementale en nous engageant
          à plusieurs niveaux.
          <br />
          <br />
          Cela se traduit par une orientation de nos méthodes de travail vers
          des alternatives ayant un impact limité sur l'environnement et les
          personnes, à travers un choix de nos fournisseurs et des produits
          proposés ainsi que nos techniques de conditionnement et transport.
        </p>
        <div className="button-info">
          <button>Nos produits Ecolabel</button>
          <button id="product">Nos produits recyclés</button>
        </div>
      </div>
    </div>
  );
};

export default CommitmentInfo;
